// QUÉ MENSAJE DEL KIT SE MANDÓ, DICHO EN EL AVISO.
//
// Lissette, 2026-10-16, por la agencia de Josep: las renovaciones de Medicare
// llegaban con el mensaje por defecto y no había forma de saber por qué desde
// la pantalla: ¿el tipo no tenía mensaje propio, o la póliza estaba guardada
// con otro tipo? El servidor ya sabe cuál eligió (`elegirMensajeDeKit` en
// deskte-api/src/routes/policies.routes.ts) y lo devuelve en `kit.mensaje`;
// esto lo convierte en la frase del aviso.

import { POLICY_TYPES } from './policyTypes.js';

/** El nombre del tipo como se ve en pantalla, con su icono. */
export function nombreDelTipoDelKit(tipo, es = true) {
  const p = POLICY_TYPES.find((x) => x.id === tipo);
  if (!p) return tipo || (es ? 'sin tipo' : 'no type');
  return `${p.icon || ''} ${es ? (p.labelEs || p.label) : p.label}`.trim();
}

/**
 * La frase que va DESPUÉS de "Kit enviado a …". Vacía si el servidor no dijo
 * nada: el aviso sale como antes.
 */
export function textoDelMensajeUsado(mensaje, es = true) {
  if (!mensaje || !mensaje.tipo) return '';
  const nombre = nombreDelTipoDelKit(mensaje.tipo, es);
  // Si salió la versión en inglés se dice: así se ve que reconoció el idioma
  // del cliente (Josef 2026-10-27).
  const ingles = mensaje.idioma === 'en' ? (es ? ' (en inglés)' : ' (English)') : '';
  return es ? ` — mensaje de: ${nombre}${ingles}` : ` — message: ${nombre}${ingles}`;
}

/** Lanza el aviso de "kit enviado" con la frase del mensaje usado. */
export function avisarKitEnviado(toast, inicio, mensaje, es = true) {
  toast.success(inicio + textoDelMensajeUsado(mensaje, es));
}

/**
 * SIN MENSAJE PERSONALIZADO NO HAY KIT (Lissette 2026-10-23: *"quita el
 * predeterminado… si una persona no tiene el mensaje personalizado para el
 * tipo de póliza no se envíe"*). El servidor contesta `reason: 'no_template'`
 * y dice qué tipo buscó; esto es la frase, con dónde escribirlo.
 *   contexto — 'prospecto' | 'renovacion' (dónde se edita ese mensaje).
 *   futuro   — true en la vista previa ("no se enviará"), antes de mandar.
 */
export function textoSinMensajeDeKit(tipo, contexto, es = true, futuro = false) {
  const nombre = nombreDelTipoDelKit(tipo, es);
  const donde = contexto === 'prospecto'
    ? (es ? 'Prospecto y Referido → Mensajes del Kit por tipo' : 'Prospects & Referrals → Kit messages by type')
    : (es ? 'Renovaciones → Kit de bienvenida' : 'Renewals → Welcome kit');
  return es
    ? `${futuro ? 'No se enviará' : 'No se envió'} el kit: "${nombre}" no tiene mensaje personalizado. Escríbelo en ${donde}. Si la póliza no es de "${nombre}", corrige su tipo.`
    : `Kit ${futuro ? 'will not be' : 'not'} sent: "${nombre}" has no custom message. Write it in ${donde}. If the policy is not "${nombre}", fix its type.`;
}
